import React from 'react';

const PrettyJSON = React.memo<{json: TAnyObject}>(({json}) => {
  return <pre>{JSON.stringify(json, null, 4)}</pre>;
});

export {PrettyJSON};
